// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\ndiv.IdInput {\n    width: 15%;\n    background-color: light-grey;\n}\n\ndiv.columns {\n    width: 50%\n}\n", ""]);
// Exports
module.exports = exports;
